import React from 'react';
import { Form, Row, Col, Button, InputGroup } from 'react-bootstrap';
import { FaUser, FaPhoneAlt, FaEnvelope, FaRegCommentDots, FaTag } from 'react-icons/fa';
import './contactform.css';

const ContactForm = () => {
  return (
    <Form className="contact-form p-4 shadow-sm rounded">
      <h3 className="form-heading mb-4 text-center">Get in Touch</h3> {/* ✅ Heading added */}

      <Row className="mb-3">
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaUser /></InputGroup.Text>
            <Form.Control type="text" placeholder="Enter your name" />
          </InputGroup>
        </Col>
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaPhoneAlt /></InputGroup.Text>
            <Form.Control type="tel" placeholder="Enter your number" />
          </InputGroup>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaEnvelope /></InputGroup.Text>
            <Form.Control type="email" placeholder="Enter your email" />
          </InputGroup>
        </Col>
        <Col xs={12} md={6}>
          <InputGroup className="mb-3">
            <InputGroup.Text className="form-icon"><FaTag /></InputGroup.Text>
            <Form.Control type="text" placeholder="Enter subject" />
          </InputGroup>
        </Col>
      </Row>

      <InputGroup className="mb-4">
        <InputGroup.Text className="form-icon"><FaRegCommentDots /></InputGroup.Text>
        <Form.Control as="textarea" rows={5} placeholder="Write your message" />
      </InputGroup>

      <Button type="submit" className="btn-primary btn-send w-100">
        Submit Now
      </Button>
    </Form>
  );
};

export default ContactForm;
